/** Runtime flags from the URL. `?memory=1` forces in-memory storage, `?empty=1` skips the demo seed. */
export interface Flags {
  storage: 'indexeddb' | 'memory';
  seedDemo: boolean;
  /** Scheduler tick in ms (default 30 000). */
  tickMs: number;
  dbName: string;
  /** Start the scheduler automatically (browser only). */
  autoStart: boolean;
  /** Demo clock starts at 10:00 on a working day regardless of the real time of day (default on; `?realtime=1` turns it off). Unit tests leave it unset. */
  anchorDemoClock?: boolean;
}

function param(search: string, hash: string, name: string): string | null {
  const fromSearch = new URLSearchParams(search).get(name);
  if (fromSearch !== null) return fromSearch;
  const q = hash.indexOf('?');
  return q >= 0 ? new URLSearchParams(hash.slice(q + 1)).get(name) : null;
}

export function resolveFlags(
  input?: { search?: string; hash?: string; hasIndexedDb?: boolean; isBrowser?: boolean },
): Flags {
  const loc = (globalThis as { location?: { search: string; hash: string } }).location;
  const search = input?.search ?? loc?.search ?? '';
  const hash = input?.hash ?? loc?.hash ?? '';
  const hasIdb = input?.hasIndexedDb ?? typeof globalThis.indexedDB !== 'undefined';
  const isBrowser = input?.isBrowser ?? typeof (globalThis as { window?: unknown }).window !== 'undefined';
  const forced = param(search, hash, 'memory') === '1';
  const tick = Number(param(search, hash, 'tick'));
  return {
    storage: forced || !hasIdb ? 'memory' : 'indexeddb',
    seedDemo: param(search, hash, 'empty') !== '1',
    tickMs: Number.isFinite(tick) && tick >= 100 ? tick : 30_000,
    dbName: param(search, hash, 'db') ?? 'planella',
    autoStart: isBrowser,
    anchorDemoClock: param(search, hash, 'realtime') !== '1',
  };
}
